import { createFileRoute } from '@tanstack/react-router';

import { queries } from '../common/api/queryKeys/queries';
import { CustomerCompaniesPage } from '../group/customer/companies/CustomerCompaniesPage';

export const Route = createFileRoute('/_app/customer-groups/$groupId/companies/')({
    component: CustomerCompaniesPage,
    async loader({ params, context }) {
        return context.queryClient.ensureQueryData(queries.customers.list({ groupId: params.groupId }));
    },
});
